import { LogoNavIcon, UserUpdateIcon, UserVoiceIcon } from "../../assets/icon";
import ChatBlue from '../../assets/images/chat-blue.png'
import ChatNeutral from '../../assets/images/chat-neutral.png'

export const TopNav: React.FC = () => {
  const storedData = localStorage.getItem("userDetails");
  const data = storedData ? JSON.parse(storedData) : null;
  return (
<header className="flex items-center justify-between sticky  left-0 w-full  py-3 z-50 ">
      {/* Welcome pill */}
      <div className="flex items-center gap-2 bg-[#FDFBF2] border-2 border-[#000] rounded-full px-4 py-2">
        <span className="flex items-center">
          <img src={ChatNeutral} alt="ChatNeutral" />
        </span>
        <span className="text-gray-900 text-sm">
          Welcome, <strong>{data?.first_name}</strong>. Get stuff done faster with ConvoHubAI
        </span>
      </div>

      {/* Right side buttons */}
      <div className="flex items-center gap-2">
        <button className="flex items-center gap-2 bg-[#FFFFFF] rounded-xl px-4 py-2 text-[14px] text-[#3A3428] font-medium hover:bg-violet-100 transition-colors">
          <img src={ChatNeutral} alt="ChatBlue" />
          <span>ConvoAI</span>
        </button>

        <button className="flex items-center gap-2 bg-[#FFFFFF] text-[#3A3428] rounded-xl px-4 py-2 text-[14px] font-medium hover:bg-gray-50 transition-colors">
          <UserVoiceIcon />
          <span>Talk to Us</span>
        </button>

        <button className="flex items-center gap-2 bg-[#FFFFFF] rounded-xl pl-2 pr-3 py-2 text-[14px] text-[#3A3428] font-medium hover:bg-gray-50 transition-colors">
          <LogoNavIcon />
          <span>{data?.first_name}</span>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6 9L12 15L18 9" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
      </div>
    </header>
  );
};